import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import axios from 'axios';
import Drip from 'drip';
import { formatPositionItem } from '@/utils/';
import { isProd, ajaxPreUrl } from '@/config/';
import { API_GET_POSITION_DETAIL, API_GET_AD_DETAIL, API_GET_KINGKONG_DETAIL, API_GET_RECOMMEND_LIST, API_GET_SHOW_RECOMMEND_LIST, API_GET_PERFORMANCE_DETAIL, API_GET_TODAT_LIST, API_GET_ARTIST_LIST, API_GET_CONFIG, API_GET_CALENDAR_LIST, API_GET_BRAND_LIST, API_GET_RECOMMEND_BRAND, API_GET_BRAND_DETAIL, API_GET_SPECIAL_OFFER, API_GET_EARLY_BIRD, API_GET_SPECIAL_OFFER_NEW, API_GET_EARLY_BIRD_NEW, API_QUICK_SELECT_TYPE_LIST, API_UPCOMMING_PROJLIST, API_GET_BRAND_GROUP_LIST, API_TICKET_STATION, API_DAILY_COUPON, API_PERFORMANCE_CALENDAR_DAILY_COUPON, API_BROADCAST_RECOMMEND_DATA, API_BROADCAST_LIST } from '@/apis';
import { owlReportError } from '@/utils/monitor-err/index';

// 演出首页中通猫眼广告位idmap
var adPositionIdMap = {
  // 猫眼APP
  maoyan: {
    channelId: 1,
    positionIds: 1024
  },
  // 美团APP
  meituan: {
    channelId: 3,
    positionIds: 1030
  },
  // 点评APP
  dianping: {
    channelId: 6,
    positionIds: 1033
  },
  // 猫眼小程序
  wxapp_wallet: {
    channelId: 40002,
    positionIds: 1037
  },
  // 格瓦拉
  gewara: {
    channelId: 1,
    positionIds: 1218
  }
};
var _Drip$constant = Drip.constant,
  cityId = _Drip$constant.cityId,
  userId = _Drip$constant.userId,
  uuid = _Drip$constant.uuid,
  appName = _Drip$constant.uaInfo.appName;
var maoyanAd = adPositionIdMap[appName] || {
  channelId: 1,
  positionIds: 1024
};
// 深色： https://p1.meituan.net/myvideodistribute/0a01554e157f4d4f7c8824e3a37b55bb36545.png
// 浅色： https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png
function defaultPosterUrl() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (a) {
    a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
    return a;
  });
}

/** 拼接cityId */
var getUrlWithCityId = function getUrlWithCityId(baseUrl, cityId) {
  if (cityId) return baseUrl.includes('?') ? "".concat(baseUrl, "&cityId=").concat(cityId) : "".concat(baseUrl, "?cityId=").concat(cityId);
  return baseUrl;
};
/**
 * 根据艺人的id，获取艺人列表
 * @param {Array} ipIds
 */
export function fetchArtistList() {
  return _fetchArtistList.apply(this, arguments);
}

/**
 * 获取首页今日必抢的列表
 */
function _fetchArtistList() {
  _fetchArtistList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context3.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context3.abrupt("return", axios.get(API_GET_ARTIST_LIST, {
            params: params
          }).then(function (_ref9) {
            var code = _ref9.code,
              data = _ref9.data,
              success = _ref9.success;
            // 后端新的服务 数据结构没有code， 通过success判断
            // if ( code !== 200 ) return []
            if (!success) return [];
            return data || [];
          }).catch(function (e) {
            owlReportError('演出首页-艺人列表接口-', e);
            return [];
          }));
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchArtistList.apply(this, arguments);
}
export function fetchTodayList() {
  return _fetchTodayList.apply(this, arguments);
}

/**
 * 获取项目详情
 * @param {Array} pids 项目id数组
 */
function _fetchTodayList() {
  _fetchTodayList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context4.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context4.abrupt("return", axios.get("".concat(API_GET_TODAT_LIST), {
            params: params
          }).then(function (_ref10) {
            var code = _ref10.code,
              data = _ref10.data;
            if (code !== 200) return [];
            return data || [];
          }).catch(function (e) {
            owlReportError('演出首页-今日必抢接口-', e);
            return [];
          }));
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _fetchTodayList.apply(this, arguments);
}
export function fetchPerformances() {
  var pids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!pids || pids.length === 0) return [];
  return axios.get("".concat(API_GET_PERFORMANCE_DETAIL, "?pids=").concat(pids.join(','))).then(function (_ref) {
    var code = _ref.code,
      data = _ref.data;
    if (code !== 200) return [];
    return defaultPosterUrl(data || []);
  }).catch(function (e) {
    owlReportError('演出首页-项目详情列表接口-', e);
    return [];
  });
}

/**
 * 获取推荐项目列表
 * @param {number} [pageNo=1] 页数
 */
export function fetchRecommendList() {
  var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  // 性能优化，由于首屏数据不需要太多，修改为每页10条数据，
  return axios.get("".concat(API_GET_RECOMMEND_LIST, "/0;st=4;p=").concat(pageNo, ";s=").concat(pageSize, ";tft=0?pageSource=1")).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function (e) {
    owlReportError('演出首页-推荐项目列表接口-', e);
    return {
      code: 500,
      data: []
    };
  });
}

/**
 * 猫眼演出首页推荐项目列表
 * @param {number} [pageNo=1] 页数
 */
export function fetchShowRecommendList() {
  var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var uuid = Drip.constant.uuid || '';
  return axios.get("".concat(API_GET_SHOW_RECOMMEND_LIST, "?pageNo=").concat(pageNo, "&pageSize=").concat(pageSize, "&pageSource=1&source=1")).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function (e) {
    owlReportError('演出首页-猫眼演出首页推荐项目列表接口-', e);
    return {
      code: 500,
      data: []
    };
  });
}

// 获取为你推荐-折扣标签 ABtest
export var getABtest = /*#__PURE__*/function () {
  var _getABtest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var params, _uuid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(Drip.UA.IS_MEITUAN || Drip.UA.IS_DIANPING)) {
            _context.next = 10;
            break;
          }
          params = {};
          _context.next = 4;
          return Drip.getUuid();
        case 4:
          _uuid = _context.sent;
          if (Drip.UA.IS_MEITUAN) {
            params = !isProd ? {
              olapeId: 496,
              layerId: 67,
              filterId: _uuid
            } : {
              olapeId: 52,
              layerId: 164,
              filterId: _uuid
            };
          }
          if (Drip.UA.IS_DIANPING) {
            params = !isProd ? {
              olapeId: 496,
              layerId: 68,
              filterId: _uuid
            } : {
              olapeId: 52,
              layerId: 165,
              filterId: _uuid
            };
          }
          return _context.abrupt("return", axios.get("".concat(ajaxPreUrl, "/getMatchedFeature"), {
            params: params
          }).then(function (_ref2) {
            var code = _ref2.code,
              data = _ref2.data;
            if (code !== 200) return {};
            var abtest = 0;
            if (data === 107 || data === 109 || data === 350 || data === 352) {
              abtest = 1;
            }
            if (data === 108 || data === 110 || data === 351 || data === 353) {
              abtest = 2;
            }
            return {
              abtest: abtest
            };
          }).catch(function () {
            return {};
          }));
        case 10:
          return _context.abrupt("return", {});
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getABtest() {
    return _getABtest.apply(this, arguments);
  }
  return getABtest;
}();

/**
 * 获取演出的资源位
 * @param {string} positionIds 资源位的Id列表, eg: 1,2,3
 */
export function fetchMyShowPositions(_x) {
  return _fetchMyShowPositions.apply(this, arguments);
}

// 获取猫眼的广告位
function _fetchMyShowPositions() {
  _fetchMyShowPositions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(positionIds) {
    var projectId,
      failFunc,
      uuid,
      osName,
      params,
      _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          projectId = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 0;
          failFunc = _args5.length > 2 ? _args5[2] : undefined;
          _context5.next = 4;
          return Drip.getUuid();
        case 4:
          uuid = _context5.sent;
          if (Array.isArray(positionIds)) {
            positionIds = positionIds.join(',');
          }
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2,
            positionIds: positionIds
          };
          projectId && (params.projectId = projectId);
          return _context5.abrupt("return", axios.get(API_GET_POSITION_DETAIL, {
            params: params
          }).then(function (_ref11) {
            var code = _ref11.code,
              data = _ref11.data;
            if (code !== 200) {
              failFunc && failFunc();
              return [];
            }
            data = data || [];
            data.forEach(function (a) {
              var positionId = a.positionId;
              a.adVOList.forEach(function (ad) {
                ad.positionId = positionId;
              });
              a.adVOList = formatPositionItem(a.adVOList);
            });
            return data;
          }).catch(function (e) {
            owlReportError('演出首页-演出的资源位接口-', e);
            failFunc && failFunc();
            return [];
          }));
        case 10:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _fetchMyShowPositions.apply(this, arguments);
}
export function fetchMaoyanADList() {
  var _Drip$constant2 = Drip.constant,
    cityId = _Drip$constant2.cityId,
    userId = _Drip$constant2.userId,
    uuid = _Drip$constant2.uuid,
    appName = _Drip$constant2.uaInfo.appName;
  var _Drip$UA = Drip.UA,
    osName = _Drip$UA.osName,
    appVersion = _Drip$UA.appVersion;
  osName = ['ios', 'iphone', 'ipad', 'android', 'touch', 'wechat_small_program', 'windows'].includes(osName) ? osName : 'windows';
  // clientType: 取值范围：ios,iphone,ipad,android,touch,wechat_small_program,windows
  // version_name(支持版本定投的广告位必填)
  var params = Object.assign({
    ci: cityId || 1,
    clientType: osName,
    version_name: appVersion
  }, maoyanAd);
  var adsUrl = isProd ? '//ad.maoyan.com/api/position/detail' : 'http://ad.movie.test.sankuai.com/api/position/detail';
  if (userId) {
    params.userid = userId;
  }
  if (uuid) {
    params.uuid = uuid;
  }
  return axios.get(adsUrl, {
    params: params
  }).then(function (_ref3) {
    var success = _ref3.success,
      data = _ref3.data;
    if (success && data && data.length > 0) {
      var list = data[0].config || [];
      var _ref4 = data[0] || {},
        positionId = _ref4.positionId;
      list.forEach(function (a) {
        a.positionId = positionId;
      });
      return formatPositionItem(list);
    }
    return [];
  }).catch(function (e) {
    owlReportError('演出首页-猫眼的广告位接口-', e);
    return [];
  });
}
export function loadNewHome() {
  return _loadNewHome.apply(this, arguments);
}

/**
 * 演出资源位合并接口
 */
function _loadNewHome() {
  _loadNewHome = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.abrupt("return", axios.get(API_GET_CONFIG).then(function (_ref12) {
            var code = _ref12.code,
              data = _ref12.data;
            if (code !== 200) return false;
            try {
              var _Drip$constant3 = Drip.constant,
                _Drip$constant3$cityI = _Drip$constant3.cityId,
                _cityId = _Drip$constant3$cityI === void 0 ? 1 : _Drip$constant3$cityI,
                sellChannel = _Drip$constant3.sellChannel;
              data = JSON.parse(data);
              if (data.allCity) {
                // 全部城市都切换到新版的首页
                return true;
              }
              var cityIdList = [];
              if (sellChannel === 1) {
                // 点评cityId
                cityIdList = data && data.dianCityIdList || [];
              } else {
                // 美团cityId
                cityIdList = data && data.meiIdList || [];
              }
              return cityIdList.includes(+_cityId);
            } catch (e) {
              return false;
            }
          }).catch(function () {
            return false;
          }));
        case 1:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  return _loadNewHome.apply(this, arguments);
}
var needFormatKeys = ['middleBannerAds', 'recommendAds', 'goldenAds'];
export function fetchMyShowAds(_x2) {
  return _fetchMyShowAds.apply(this, arguments);
}

/**
 * 获取金刚位详情（新接口）
 * 替代原 fetchMyShowAds 中 goldenAds 部分：品类金刚位（1219）、角标（1230）、
 * 运营金刚位（2441）均由服务端组装完毕，前端直接消费 KingKongVO 模型。
 * 参考文档：https://bcn6l25kip9n.feishu.cn/wiki/E1FLw6b2FiCgGNkuEEVc88DBn4g
 */
function _fetchMyShowAds() {
  _fetchMyShowAds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(cityId) {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context7.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context7.abrupt("return", axios.get(getUrlWithCityId(API_GET_AD_DETAIL, cityId), {
            params: params
          }).then(function (_ref13) {
            var code = _ref13.code,
              data = _ref13.data;
            if (code !== 200) return {};
            data = data || {};
            needFormatKeys.forEach(function (key) {
              var adList = data[key];
              if (!adList) return;
              adList.forEach(function (ad) {
                var positionId = ad.positionId;
                ad.adVOList.forEach(function (ad) {
                  ad.positionId = positionId;
                });
                ad.adVOList = formatPositionItem(ad.adVOList);
              });
            });
            return data;
          }).catch(function (e) {
            owlReportError('演出首页-演出资源位合并接口-', e);
            return [];
          }));
        case 6:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  return _fetchMyShowAds.apply(this, arguments);
}
export function fetchKingKongDetail() {
  return _fetchKingKongDetail.apply(this, arguments);
}

// 日历快筛类型列表查询
function _fetchKingKongDetail() {
  _fetchKingKongDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var _Drip$constant4, cityId, sellChannel, params;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _Drip$constant4 = Drip.constant, cityId = _Drip$constant4.cityId, sellChannel = _Drip$constant4.sellChannel;
          params = {};
          if (cityId) params.cityId = cityId;
          if (sellChannel !== null && sellChannel !== undefined) {
            params.sellChannel = sellChannel;
          }
          return _context8.abrupt("return", axios.get(API_GET_KINGKONG_DETAIL, {
            params: params
          }).then(function (_ref14) {
            var success = _ref14.success,
              data = _ref14.data;
            if (!success) return null;
            return data || null;
          }).catch(function (e) {
            owlReportError('演出首页-金刚位详情新接口-', e);
            return null;
          }));
        case 5:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _fetchKingKongDetail.apply(this, arguments);
}
export function fetchQuickSelectTypeList(_x3, _x4) {
  return _fetchQuickSelectTypeList.apply(this, arguments);
}
function _fetchQuickSelectTypeList() {
  _fetchQuickSelectTypeList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref5, cityId) {
    var startDate, endDate, uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          startDate = _ref5.startDate, endDate = _ref5.endDate;
          _context9.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context9.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2,
            startDate: startDate,
            endDate: endDate
          };
          return _context9.abrupt("return", axios.get(getUrlWithCityId(API_QUICK_SELECT_TYPE_LIST, cityId), {
            params: params
          }).then(function (_ref15) {
            var code = _ref15.code,
              data = _ref15.data;
            if (code !== 200) return [];
            return data || [];
          }).catch(function (e) {
            owlReportError('演出首页-日历快筛类型列表查询-', e);
            return [];
          }));
        case 7:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _fetchQuickSelectTypeList.apply(this, arguments);
}
var getBaseParams = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context2.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context2.abrupt("return", params);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getBaseParams() {
    return _ref6.apply(this, arguments);
  };
}();

// 获取抢票播放站接口
export function fetchTicketStation() {
  return _fetchTicketStation.apply(this, arguments);
}
// 获取天天神券
function _fetchTicketStation() {
  _fetchTicketStation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var params, body;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return getBaseParams();
        case 2:
          params = _context10.sent;
          _context10.prev = 3;
          _context10.next = 6;
          return axios.get("".concat(API_TICKET_STATION), {
            params: params,
            headers: {}
          });
        case 6:
          body = _context10.sent;
          if (body.data) {
            body.data.posterUrl = body.data.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
          }
          return _context10.abrupt("return", body);
        case 11:
          _context10.prev = 11;
          _context10.t0 = _context10["catch"](3);
          owlReportError('演出首页-获取抢票播放站接口-', _context10.t0);
          return _context10.abrupt("return", {
            success: false,
            data: null
          });
        case 15:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[3, 11]]);
  }));
  return _fetchTicketStation.apply(this, arguments);
}
export function fetchDailyCoupon() {
  return _fetchDailyCoupon.apply(this, arguments);
}

// 获取演出日历和天天神券
function _fetchDailyCoupon() {
  _fetchDailyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var params, body;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return getBaseParams();
        case 2:
          params = _context11.sent;
          _context11.prev = 3;
          _context11.next = 6;
          return axios.get("".concat(API_DAILY_COUPON), {
            params: params,
            headers: {}
          });
        case 6:
          body = _context11.sent;
          if (body.data && body.data.dailyCouponGroupProjects) {
            body.data.dailyCouponGroupProjects = defaultPosterUrl(body.data.dailyCouponGroupProjects || []);
          }
          return _context11.abrupt("return", body);
        case 11:
          _context11.prev = 11;
          _context11.t0 = _context11["catch"](3);
          owlReportError('演出首页-获取天天神券接口-', _context11.t0);
          return _context11.abrupt("return", {
            success: false,
            data: null
          });
        case 15:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[3, 11]]);
  }));
  return _fetchDailyCoupon.apply(this, arguments);
}
export function fetcPerformanceCalendarhDailyCoupon() {
  return _fetcPerformanceCalendarhDailyCoupon.apply(this, arguments);
}

// 获取临演
function _fetcPerformanceCalendarhDailyCoupon() {
  _fetcPerformanceCalendarhDailyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var _body$data, _body$data$dailyCoupo, params, body, _body$data2, _body$data2$dailyCoup;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return getBaseParams();
        case 3:
          params = _context12.sent;
          _context12.next = 6;
          return axios.get("".concat(API_PERFORMANCE_CALENDAR_DAILY_COUPON), {
            params: params,
            headers: {}
          });
        case 6:
          body = _context12.sent;
          if ((_body$data = body.data) !== null && _body$data !== void 0 && (_body$data$dailyCoupo = _body$data.dailyCouponGroupVO) !== null && _body$data$dailyCoupo !== void 0 && _body$data$dailyCoupo.dailyCouponGroupProjects) {
            body.data.dailyCouponGroupVO.dailyCouponGroupProjects = defaultPosterUrl((body === null || body === void 0 ? void 0 : (_body$data2 = body.data) === null || _body$data2 === void 0 ? void 0 : (_body$data2$dailyCoup = _body$data2.dailyCouponGroupVO) === null || _body$data2$dailyCoup === void 0 ? void 0 : _body$data2$dailyCoup.dailyCouponGroupProjects) || []);
          }
          return _context12.abrupt("return", body);
        case 11:
          _context12.prev = 11;
          _context12.t0 = _context12["catch"](0);
          owlReportError('演出首页-获取演出日历和天天神券接口-', _context12.t0);
          return _context12.abrupt("return", {
            success: false,
            data: null
          });
        case 15:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 11]]);
  }));
  return _fetcPerformanceCalendarhDailyCoupon.apply(this, arguments);
}
export function fetchSpecialOffer() {
  return _fetchSpecialOffer.apply(this, arguments);
}
// 获取早鸟
function _fetchSpecialOffer() {
  _fetchSpecialOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var filterProjectIds,
      uuid,
      osName,
      params,
      api,
      _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          filterProjectIds = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : [];
          _context13.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context13.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2,
            pageNo: 1,
            pageSize: 40,
            filterProjectIds: filterProjectIds.join(',')
          };
          api = API_GET_SPECIAL_OFFER_NEW;
          return _context13.abrupt("return", axios.get("".concat(api), {
            params: params
          }).then(function (body) {
            body.data = defaultPosterUrl(body.data || []);
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-获取临演接口-', e);
            return {
              code: 500,
              data: []
            };
          }));
        case 8:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return _fetchSpecialOffer.apply(this, arguments);
}
export function fetchEarlyBird() {
  return _fetchEarlyBird.apply(this, arguments);
}
// 首页新日历接口
function _fetchEarlyBird() {
  _fetchEarlyBird = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var uuid, osName, params, api;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context14.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2,
            pageNo: 1,
            pageSize: 40
          };
          api = API_GET_EARLY_BIRD_NEW;
          return _context14.abrupt("return", axios.get("".concat(api), {
            params: params
          }).then(function (body) {
            body.data = defaultPosterUrl(body.data || []);
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-获取早鸟接口-', e);
            return {
              code: 500,
              data: []
            };
          }));
        case 7:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return _fetchEarlyBird.apply(this, arguments);
}
export function fetchNewCalendarList(_x5, _x6) {
  return _fetchNewCalendarList.apply(this, arguments);
}

// 日历播报站推荐接口
function _fetchNewCalendarList() {
  _fetchNewCalendarList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(data, cityId) {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          return _context15.abrupt("return", axios.post(getUrlWithCityId(API_UPCOMMING_PROJLIST, cityId), data).then(function (body) {
            body.data = defaultPosterUrl(body.data || []);
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-首页新日历接口-', e);
            return {
              code: 500,
              data: []
            };
          }));
        case 1:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return _fetchNewCalendarList.apply(this, arguments);
}
export function fetchBroadcastRecommendData(_x7, _x8) {
  return _fetchBroadcastRecommendData.apply(this, arguments);
}

// 日历播报站列表接口
function _fetchBroadcastRecommendData() {
  _fetchBroadcastRecommendData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(data, cityId) {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          return _context16.abrupt("return", axios.get(getUrlWithCityId(API_BROADCAST_RECOMMEND_DATA, cityId), {
            params: data
          }).then(function (body) {
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-首页新日历接口-', e);
            return {
              code: 500,
              data: {},
              success: false
            };
          }));
        case 1:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return _fetchBroadcastRecommendData.apply(this, arguments);
}
export function fetchBroadcastList(_x9, _x10) {
  return _fetchBroadcastList.apply(this, arguments);
}

/**
 * 获取日历模块列表
 * @param {number} [pageNo=1] 页数
 * @param {number} [pageSize=1] 页数
 */
function _fetchBroadcastList() {
  _fetchBroadcastList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(data, cityId) {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          return _context17.abrupt("return", axios.get(getUrlWithCityId(API_BROADCAST_LIST, cityId), {
            params: data
          }).then(function (body) {
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-日历播报站列表接口-', e);
            return {
              code: 500,
              data: [],
              success: false
            };
          }));
        case 1:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return _fetchBroadcastList.apply(this, arguments);
}
export function fetchCalendarList(_x11) {
  return _fetchCalendarList.apply(this, arguments);
}

/**
 * 获取品牌推荐列表
 */
function _fetchCalendarList() {
  _fetchCalendarList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref7) {
    var _ref7$pageNo, pageNo, _ref7$pageSize, pageSize, startDay, endDay, timeFilterType, uuid, osName, params, type, time;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _ref7$pageNo = _ref7.pageNo, pageNo = _ref7$pageNo === void 0 ? 1 : _ref7$pageNo, _ref7$pageSize = _ref7.pageSize, pageSize = _ref7$pageSize === void 0 ? 20 : _ref7$pageSize, startDay = _ref7.startDay, endDay = _ref7.endDay, timeFilterType = _ref7.timeFilterType;
          _context18.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context18.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          type = timeFilterType ? ";timeFilterType=".concat(timeFilterType) : '';
          time = startDay && endDay ? "?sd=".concat(startDay, "&ed=").concat(endDay) : "";
          return _context18.abrupt("return", axios.get("".concat(API_GET_CALENDAR_LIST, "/0;pageNo=").concat(pageNo, ";pageSize=").concat(pageSize, ";st=10").concat(type).concat(time), {
            params: params
          }).then(function (body) {
            body.data = defaultPosterUrl(body.data || []);
            return body;
          }).catch(function (e) {
            owlReportError('演出首页-获取日历模块列表接口-', e);
            return {
              code: 500,
              data: []
            };
          }));
        case 9:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return _fetchCalendarList.apply(this, arguments);
}
export function fetchBrandList() {
  return _fetchBrandList.apply(this, arguments);
}

/**
 * 为你推荐品牌卡
 */
function _fetchBrandList() {
  _fetchBrandList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context19.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context19.abrupt("return", axios.get(API_GET_BRAND_LIST, {
            params: params
          }).then(function (_ref16) {
            var code = _ref16.code,
              data = _ref16.data;
            if (code !== 200) return [];
            return data || [];
          }).catch(function (e) {
            owlReportError('演出首页-获取品牌推荐列表-', e);
            return [];
          }));
        case 6:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return _fetchBrandList.apply(this, arguments);
}
export function fetchRecommendBrand() {
  return _fetchRecommendBrand.apply(this, arguments);
}

/**
 * 查询品牌详情
 */
function _fetchRecommendBrand() {
  _fetchRecommendBrand = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context20.sent;
          osName = Drip.UA.osName;
          params = {
            uuid: uuid,
            clientType: osName === 'ios' ? 1 : 4,
            os: osName === 'ios' ? 1 : 2
          };
          return _context20.abrupt("return", axios.get(API_GET_RECOMMEND_BRAND, {
            params: params
          }).then(function (_ref17) {
            var code = _ref17.code,
              data = _ref17.data;
            if (code !== 200) return [];
            return data || [];
          }).catch(function (e) {
            owlReportError('演出首页-为你推荐品牌卡-', e);
            return [];
          }));
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return _fetchRecommendBrand.apply(this, arguments);
}
export function fetchBrandDetail(brandId) {
  return axios.get("".concat(API_GET_BRAND_DETAIL, "/").concat(brandId)).then(function (body) {
    return body;
  }).catch(function (e) {
    owlReportError('品牌详情接口-', e);
    return {
      code: 500,
      data: []
    };
  });
}

/**
 * 查询品牌项目
 */
export function fetchBrandProjectList(_ref8) {
  var brandId = _ref8.brandId,
    _ref8$pageNo = _ref8.pageNo,
    pageNo = _ref8$pageNo === void 0 ? 1 : _ref8$pageNo;
  return axios.get("".concat(API_GET_RECOMMEND_LIST, "/0;st=4;p=").concat(pageNo, ";s=20;tft=0?brandId=").concat(brandId)).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function (e) {
    owlReportError('品牌详情页-查询品牌项目-', e);
    return {
      code: 500,
      data: []
    };
  });
}

/**
 * 查询品牌团购项目列表
 */
export function getBrandGroupList(brandId) {
  var pageNo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return axios.get("".concat(API_GET_BRAND_GROUP_LIST, "?pageNo=").concat(pageNo, "&pageSize=20&brandId=").concat(brandId)).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function (e) {
    owlReportError('演出首页-查询品牌团购项目列表-', e);
    return {
      code: 500,
      data: []
    };
  });
}